module.exports = __webpack_public_path__ + "img/twitter.10d05d5.png";